import { render, staticRenderFns } from "./ProfileInvoices.vue?vue&type=template&id=a578c4e6&scoped=true&"
import script from "./ProfileInvoices.vue?vue&type=script&lang=js&"
export * from "./ProfileInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInvoices.vue?vue&type=style&index=0&id=a578c4e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a578c4e6",
  null
  
)

export default component.exports